import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "dz_cookie_consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const answer = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[80] mx-auto max-w-2xl rounded-lg border border-line bg-white p-5 shadow-lg shadow-navy/10"
          data-testid="cookie-banner"
        >
          <div className="flex items-start gap-3">
            <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-navy" />
            <div className="flex-1">
              <p className="text-sm font-bold text-navy">Folosim cookie-uri</p>
              <p className="mt-1 text-sm leading-snug text-muted2">
                Folosim cookie-uri strict necesare și, cu acordul tău, cookie-uri de analiză pentru a îmbunătăți site-ul.{" "}
                <Link to="/legal#cookies" className="font-semibold text-navy underline" data-testid="cookie-banner-details">
                  Află mai multe
                </Link>
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <button
                  onClick={() => answer("accepted")}
                  className="h-11 rounded-lg bg-navy px-5 text-sm font-bold text-white transition-colors hover:bg-navy-dark"
                  data-testid="cookie-accept-button"
                >
                  Accept toate
                </button>
                <button
                  onClick={() => answer("necessary")}
                  className="h-11 rounded-lg border-[1.5px] border-navy px-5 text-sm font-bold text-navy transition-colors hover:bg-skytint"
                  data-testid="cookie-necessary-button"
                >
                  Doar cele necesare
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
